import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Tooltip } from "@similarweb/ui-components";

import I18n from "pro-features/components/WithTranslation/src/I18n";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const BannerContainer = styled(FlexRow)`
    background-color: ${colorsPalettes.bluegrey[200]};
    padding: 0 16px;
    border-radius: 3px;
    align-items: center;
    min-height: 48px;
`;

const BannerText = styled(I18n)`
    ${setFontVariant("subtitle2", colorsPalettes.carbon[500])};
    margin: 0 8px;
`;

const StyledIcon = styled(SWReactIcons)`
    flex-shrink: 0;
`;

export const AdIntelMetricsUnavailableBanner = ({
    text = "display.advertising.adintelligence.metrics.unavailable.banner.message",
    tooltipText = "display.advertising.adintelligence.metrics.unavailable.tooltip.message",
}: {
    text?: string;
    /** Pass `null` to render the banner without the trailing info tooltip. */
    tooltipText?: string | null;
}) => {
    return (
        <BannerContainer>
            <StyledIcon
                iconName="alerts"
                size="sm"
                iconColor={colorsPalettes.carbon[300]}
            />
            <BannerText>{text}</BannerText>
            {tooltipText ? (
                <Tooltip
                    placement="top"
                    content={<I18n>{tooltipText}</I18n>}
                >
                    <SWReactIcons
                        iconName="info"
                        size="xs"
                        iconColor={colorsPalettes.carbon[300]}
                    />
                </Tooltip>
            ) : null}
        </BannerContainer>
    );
};
